const scrollToInvalid = () => {
    if ( $(window).width() > 991 ) {
        return
    }
    const time = 400;
    const offset = 100;

    document.addEventListener('invalid', function(e){
        $(e.target).addClass("is-invalid");
        $('html, body').animate({scrollTop: $($(".is-invalid")[0]).offset().top - offset }, time);
    }, true);
    document.addEventListener('change', function(e){
        $(e.target).removeClass("is-invalid")
    }, true);
};

scrollToInvalid();
